var _templateObject;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
var StyledGalleryDragHandle = styled(IconButton)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  cursor: grab;\n  touch-action: manipulation;\n"])));
export default StyledGalleryDragHandle;